import React, {Component} from 'react';
import * as Sentry from '@sentry/browser';
import PropTypes from 'prop-types';
import styled, {createGlobalStyle} from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: Roboto, sans-serif;
    height: calc(100vh);
    width: calc(100vw);
    overflow: hidden;
  }
  h1, h2, h3, h4, h5 {
    font-family: Roboto, sans-serif;
    margin: 0;
    padding: 0;
  }
  h1 {
    font-size: 2.5rem;
    font-weight: 700;
  }
  p {
    letter-spacing: 0.87px;
    font-size: 1rem;
    font-family: Roboto,sans-serif;
  }
`;

const Wrapper = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
`;

class App extends Component {
  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }
  
  render() {
    const {children} = this.props;
    return (
      <Wrapper>
        {children}
        <GlobalStyle/>
      </Wrapper>
    );
  }
}

App.propTypes = {
  children: PropTypes.element.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/pages/App.js